<template>
  <div>
    <swipe-active
      v-if="!!banners"
      :module-title="moduleTitle"
      :list="banners"
    />
    <swipe-active
      v-if="!!middleBanners"
      :module-title="timeModuleTitle"
      :list="middleBanners"
    />
    <!--<time-card-->
    <!--v-if="!!middleBanners"-->
    <!--:banners="middleBanners"/>-->
  </div>
</template>
<script>
import SwipeActive from '../swiper/SwipeActive'
import TimeCard from './TimeCard'
import {mapGetters} from 'vuex'

export default {
  name: 'CardItems',
  components: {TimeCard, SwipeActive},
  data () {
    return {
      timeModuleTitle: {
        title: '次卡、时长卡',
        text: '咨询更优惠'
      }
    }
  },
  computed: {
    ...mapGetters('Channel', [
      'getChannelData'
    ]),
    banners () {
      if (this.getChannelData && this.getChannelData.banners) {
        let banners = this.getChannelData.banners.filter((item) => {
          if (item.bannerPlace === this.$dataResource.bannerType.body || item.bannerPlace === this.$dataResource.bannerType.body + '') return true
        })
        if (banners.length < 1) {
          banners = false
        }
        return banners
      }
      return false
    },
    middleBanners () {
      if (this.getChannelData && this.getChannelData.banners) {
        let banners = this.getChannelData.banners.filter((item) => {
          if (item.bannerPlace === this.$dataResource.bannerType.middle || item.bannerPlace === this.$dataResource.bannerType.middle + '') return true
        })
        if (banners.length < 1) {
          banners = false
        }
        return banners
      }
      return false
    },
    moduleTitle () {
      if (this.banners) {
        let obj = {
          title: '会员卡',
          text: '畅听卡、畅享卡应有尽有'
        }
        let item = this.banners[0] || {}
        if (item.url.startsWith('go_MemberCard')) {
          obj.text = '金卡、白金卡应有尽有'
        }
        return obj
      }
      return {}
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/CardItems.vue